import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var modal = {
    selectors: {
        element:  '[data-modal]',
        trigger:  '[data-modal-trigger]',
        close:    '[data-modal-close]'
    },
    init: function() {
        var self  = this;
        var $elements = $( self.selectors.elements );
        var $triggers = $( self.selectors.trigger );
        var $closers   = $( self.selectors.close );

        $triggers.each( function() {
            this.addEventListener( 'click', function( e ) {
                e.preventDefault();
                var $target = $(e.target).attr( 'data-modal-trigger' );
                if ( $target ) {
                    var $modal = $( '[data-modal="' + $target + '"]' );
                    if ( $modal.length ) { 
                        disableBodyScroll( document.querySelector('.modal') );
                        $modal.addClass( 'modal-opened' );
                    }
                }
            });
        });

        $closers.each( function() {
            this.addEventListener( 'click', function( e ) {
                e.preventDefault();
                var $openedModals = $( '.modal-opened' );
                if ( $openedModals.length ) {
                    enableBodyScroll( document.querySelector('.modal') );
                    $openedModals.removeClass( 'modal-opened' );
                }
            });
        });

        $(document).ready(function() {
            $( '[data-modal="init"]' ).each( function() {
                disableBodyScroll( document.querySelector('.modal') );
                $( this ).addClass( 'modal-opened' );
            });
        });
    }
}

export { modal };
